export const ENTITIES = {
  INSPECTION: 'Inspection',
  INSPECTION_STEP: 'InspectionStep',
  REMARK: 'Remark',
  STANDARD: 'Standard',
  HOUSE: 'House',
  DISTRICT: 'District',
  CLIENT: 'Client',
  INSPECTION_STATUS: 'InspectionStatus',
  FILE: 'File',
  CHECK_LIST: 'CheckList',
  REMARK_TEMPLATES: 'RemarkTemplates',
  USER: 'User',
  COMPANY: 'Company',
  CITY: 'City',
  COMPANY_BADGE: 'CompanyBadge',
  COMPANY_TAG: 'CompanyTag'
}

export const ENTITY_TITLES = {
  [ENTITIES.INSPECTION]: 'Приемка',
  [ENTITIES.INSPECTION_STEP]: 'Шаг приемки',
  [ENTITIES.REMARK]: 'Замечание',
  [ENTITIES.HOUSE]: 'Дом',
  [ENTITIES.DISTRICT]: 'Проект / жилой комплекс',
  [ENTITIES.CLIENT]: 'Заказчик',
  [ENTITIES.INSPECTION_STATUS]: 'Статус приемки',
  [ENTITIES.FILE]: 'Файл',
  [ENTITIES.CHECK_LIST]: 'Чек-лист',
  [ENTITIES.STANDARD]: 'Норматив',
  [ENTITIES.REMARK_TEMPLATES]: 'Шаблон замечаний',
  [ENTITIES.USER]: 'Пользователь',
  [ENTITIES.COMPANY]: 'Компания',
  [ENTITIES.CITY]: 'Город',
  [ENTITIES.COMPANY_BADGE]: 'Знак отличия',
  [ENTITIES.COMPANY_TAG]: 'Услуга'
}
